module.exports = new __parcel__URL__("ai-draft-gen-onboarding.6ab5a78a.svg").toString();